require('./systemPreference.i18n.json');
require('./systemPreference.tpl.html');
require('./systemPreferenceController.js');

const SystemPreferenceComponent = {
    templateUrl: '/configuration/systemPreferencesManager/systemPreference/systemPreference.tpl.html',
    controller: 'systemPreferenceController',
    bindings: {
        systemPreference: '<',
        hasManagePermission:'<'
    }
};

angular.module('ums.configuration')
    .component('uiSystemPreference', SystemPreferenceComponent);
